import React, { type HTMLProps } from "react";
import { twMerge } from "tailwind-merge";

export function VaultCardLoader({ className, ...props }: HTMLProps<HTMLDivElement>) {
  return (
    <div className={twMerge("animate-pulse overflow-hidden rounded-l-2xl rounded-br-2xl border-0.5 border-primary-300", className)} {...props}>
      {/** Header */}
      <div className="relative">
        <div className="flex h-12 w-28 rounded-br-2xl rounded-tl-2xl bg-primary-50"></div>

        <div className="absolute right-3 top-2 flex flex-col items-end">
          <div className="mb-1 h-4 w-32 rounded-full bg-primary-50"></div>
          <div className="h-4 w-20 rounded-full bg-primary-50"></div>
        </div>
      </div>

      {/** Body */}
      <div className="flex h-[10.125rem] items-center gap-4 px-3">
        <span className="block h-9 w-9 rounded-full bg-primary-50" />

        <div className="block">
          <div className="mb-1 h-4 w-32 rounded-full bg-primary-50"></div>
          <div className="h-4 w-16 rounded-full bg-primary-50"></div>
        </div>
      </div>

      {/** Footer */}
      <div className="flex h-10 items-center justify-between border-t-0.5 border-primary-300 pl-3">
        <div className="mb-1 h-4 w-32 rounded-full bg-primary-50"></div>

        <div className="ml-auto flex h-10 w-36 items-center rounded-br-2xl bg-primary-50" />
      </div>
    </div>
  );
}
